<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="shrink-0"
    :class="$attrs.class"
  >
    <rect x="1" y="1" width="7" height="7" rx="0.8" />
    <rect x="9" y="1" width="7" height="7" rx="0.8" />
    <rect x="17" y="1" width="6" height="7" rx="0.8" />
    <rect x="1" y="9" width="7" height="7" rx="0.8" />
    <rect x="9" y="9" width="7" height="7" rx="0.8" />
    <rect x="17" y="9" width="6" height="7" rx="0.8" />
    <rect x="1" y="17" width="7" height="6" rx="0.8" />
    <rect x="9" y="17" width="7" height="6" rx="0.8" />
    <rect x="17" y="17" width="6" height="6" rx="0.8" stroke-dasharray="2 1.5" opacity="0.5" />
  </svg>
</template>

<script setup>
defineOptions({ inheritAttrs: false });
</script>
